import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { showFormModal } from 'state/ui'
import DataGridWithSearchV2 from 'components/generic/datagrid/DataGridWithSearchV2'
import AlertModal from 'components/generic/modals/dialog-modal/AlertModal'
import TexasCashCardCell from 'components/containers/customers/contacts/TexasCashCardCell'
import CustomerPortalInviteCell from 'components/containers/customers/contacts/CustomerPortalInviteCell'
import FORM_MODALS from 'utils/ui/modals'

const getColumns = ({ showCashCardButton, customerData, enableCustomerPortal, setShowEmailAlert }) => {
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'phone1',
      headerName: 'Primary Phone',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'locationName',
      headerName: 'Location',
      flex: 1,
    },
    {
      field: 'role',
      headerName: 'Role',
      flex: 1,
    },
    {
      field: 'notes',
      headerName: 'Notes',
      flex: 1,
    },
    {
      field: 'texasCashCard',
      headerName: 'Texas Cash Card',
      flex: 1,
      renderCell: params => <TexasCashCardCell params={params} customerData={customerData} />,
    },
    {
      field: 'customerPortalInvite',
      headerName: 'Customer Portal',
      flex: 1,
      renderCell: params => (
        <CustomerPortalInviteCell params={params} customerData={customerData} setShowEmailAlert={setShowEmailAlert} />
      ),
    },
  ]
  return columns.filter(column => {
    if (column.field === 'texasCashCard') {
      return showCashCardButton
    } else if (column.field === 'customerPortalInvite') {
      return enableCustomerPortal
    }
    return true
  })
}

const ContactGrid = ({ customerData, ...props }) => {
  const dispatch = useDispatch()

  const [showEmailAlert, setShowEmailAlert] = useState(false)

  const { settings } = useSelector(state => state.settings)
  const showCashCardButton = !!settings?.purchaseSettings?.payment?.mreEntityId

  const { enableCustomerPortal } = useSelector(state => state.featureFlags?.variables || {})

  const columns = getColumns({
    showCashCardButton,
    customerData,
    enableCustomerPortal,
    setShowEmailAlert,
  })

  return (
    <>
      {showEmailAlert && (
        <AlertModal
          open={showEmailAlert}
          modalType="payment"
          title="Customer Portal Invitation"
          question="An email address is required for portal invitation. Would you like to add one?"
          description=""
          confirmLabel="YES"
          cancelLabel="NO"
          onClose={() => {
            setShowEmailAlert(false)
          }}
          onSubmit={() => {
            setShowEmailAlert(false)
            dispatch(
              showFormModal({
                formModalName: FORM_MODALS.NEW_CUSTOMER,
                formModalProps: { customerId: customerData?.id, type: 'contacts' },
              }),
            )
          }}
        />
      )}
      <DataGridWithSearchV2 {...props} columns={columns} disableSelectionOnClick hideFooter />
    </>
  )
}

ContactGrid.propTypes = {
  ...DataGridWithSearchV2.propTypes,
  customerData: PropTypes.object,
}

ContactGrid.defaultProps = DataGridWithSearchV2.defaultProps

export default ContactGrid
